module.exports = __webpack_public_path__ + "static/sail-423315a6da898808134c1c2bbc782258.svg";